import { loadB3dm } from '../../geodata/surfaces/b3dm/loader';
import { GltfLoader } from '../gltf';

export class CesiumLoader {
  private static _instance: CesiumLoader = new CesiumLoader();

  static get instance() {
    return this._instance;
  }

  async loadB3DM(b3dmBuffer: Buffer) {
    const b3dmContent = loadB3dm(b3dmBuffer);

    return {
      header: b3dmContent.header,
      featureTable: b3dmContent.featureTable,
      glb: await GltfLoader.instance.loadGltf(Buffer.from(b3dmContent.glb)),
    };
  }
}
